import * as JQuery from "jquery";
import { triggerShowingAnnontationsPopup } from "./common";

export default function onAnnotationSaved(form: JQuery) {
    const jQuery = window.jQuery;

    // Clear all the data
    window.panelManager?.getAnnotationEditorPanel()?.clearAnnotationInputs();

    // Hide all the loading animations, sidebar
    window.panelManager?.getAnnotationEditorPanel()?.hide();

    jQuery("#annotation-reset-view").removeAttr("disabled");
    jQuery(form).parents(".ck-modal").addClass("hidden");

    jQuery(".ck-processing-loader").removeClass("shown");

    // Show the sidebar for drawing and measurements
    triggerShowingAnnontationsPopup();

    window.Construkted.project.setAnnotationModified(false);
}
